import { validate } from './validations'
import { build } from '../../../services/crudFactory'
import { Action } from '../../../services/actions.factory'
import apiCommand from '../../../services/api-command'
import { messageActions } from '../../../store/message'

const BASE_PATH = '/lottustech/relatorios'
const crud = build(validate, BASE_PATH)
const prefix = 'crudPbAtendimento'

const newTypes = {
  RESET_FORM: `${prefix}resetForm`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.resetForm = () => {
  return {
    type: types.RESET_FORM,
  }
}

actions.executeCommand = (params) => {
  return (dispatch, getState) => {
    apiCommand
      .commandAtendimento(params)
      .then((response) => {
        dispatch(messageActions.messageShowMessages(makeMessages(['Atendimento solicitado.'], 'success')))
        dispatch(actions.resetForm())
      })
      .catch((error) => {
        if (error.response) {
          const messages = error.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = ''
  if (type === 'error') {
    summary = ''
    sticky = true
  } else if (type === 'warn') {
    summary = ''
    sticky = true
  }
  return messages.map((message) => {
    return {
      sticky: sticky,
      summary: summary,
      severity: type,
      detail: message,
    }
  })
}

export { types, actions }
